import Vue from 'vue'
import Router from 'vue-router'

import i18n from '@/i18n'

Vue.use(Router)

import Layout from '@/layout/index'
// import LayoutExport from '@/layout/export'
import healthready from '@/components/health/ready.vue'

export const constantRoutes = [
  {
    path: '/',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '',
        component: () => import('@/views/brains/index'),
        name: 'home',
        meta: { title: i18n.t('router.home') }
      }
    ]
  },
  {
    path: '/ready',
    name: 'ready',
    component: healthready,
    hidden: true,
    meta: { layout: 'empty' }
  },
  {
    path: '/health',
    name: 'health',
    component: healthready,
    hidden: true,
    meta: { layout: 'empty' }
  }
]

const createRouter = () => new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

export default router
